"use client"

import { useEffect } from "react"
import { initializeDevtools } from "./initDevtools"

/**
 * Component that initializes Zustand DevTools
 * This component should be added to your providers
 */
export function DevToolsInitializer() {
  useEffect(() => {
    // Only initialize in development
    if (process.env.NODE_ENV !== "production") {
      initializeDevtools()
    }
  }, [])

  return null
}
